var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_auth),expression:"is_auth"}]},[_c('div',{staticClass:"app"},[_c('keep-alive',{attrs:{"include":_vm.include,"max":10}},[_c('router-view',{ref:"router",staticClass:"router"})],1)],1),(_vm.footer === true)?_c('Footer'):_vm._e(),(_vm.home === true)?_c('Home'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }